import Form from "./Form";

const index = () => {
  return (
    <>
      <div className="ls-widget">
        <div className="widget-title">
          <h4>Change Password</h4>
        </div>

        <div className="widget-content">
          <Form />
        </div>
      </div>
    </>
  );
};

export default index;
